import PropTypes from 'prop-types';
import { useRef, useState } from 'react';

import Button from 'shopper/components/Button';
import { Dropdown } from 'shopper/components/Dropdown';
import Icon from 'shopper/components/Icon';

import useContainerOverflow from 'hooks/useContainerOverflow';

import placeholder from 'lib/placeholder';

import CategoriesDropdown from './CategoriesDropdown';
import CombinedNavContent from './CombinedNavContent';
import NavItem from './NavItem';
import StoresDropdown from './StoresDropdown';

import LINKS from 'constants/links';

const MAIN_NAV_LISTS = [
  {
    url: LINKS.COUPONS,
    bgUrl: null,
    text: placeholder('actions.seeCoupons'),
    gaEventAction: 'topbar_coupon_tab',
    icon: null,
  },
];
const START_INDEX_COUNTING_SIBLINGS = 2 + MAIN_NAV_LISTS.length;

const TopbarBottom = ({ gaEventCategory }) => {
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const dropdownButtonRef = useRef(null);

  const {
    addContentRef,
    containerRef,
    overflowMap,
    lastOverflowedItemOffsetLeft,
  } = useContainerOverflow({
    deps: [isDropdownOpen],
    threshold: 70,
  });

  const overflowMapItemsWithOverflow = Object.values(overflowMap).some(Boolean);
  const startIndexCountingSiblings = START_INDEX_COUNTING_SIBLINGS;

  return (
    <div className="relative flex w-full max-w-full items-center justify-start gap-x-2">
      <CategoriesDropdown gaEventCategory={gaEventCategory} />
      <StoresDropdown gaEventCategory={gaEventCategory} />
      <nav
        ref={containerRef}
        className="flex w-full max-w-full items-center justify-start gap-x-2 overflow-x-hidden py-px pl-1"
      >
        {MAIN_NAV_LISTS.map(({ bgUrl, gaEventAction, icon, text, url }) => (
          <NavItem
            key={url}
            bgUrl={bgUrl}
            gaEventAction={gaEventAction}
            gaEventCategory={gaEventCategory}
            icon={icon}
            text={text}
            unreadStatus={url === LINKS.ALIEXPRESS_STORE}
            url={url}
          />
        ))}
        <CombinedNavContent
          addContentRef={addContentRef}
          gaEventCategory={gaEventCategory}
          overflowMap={overflowMap}
          startIndex={startIndexCountingSiblings}
        />
      </nav>
      {overflowMapItemsWithOverflow && (
        <div
          className="absolute -top-1 ml-3 lg:flex"
          style={{ left: lastOverflowedItemOffsetLeft }}
        >
          <Button
            ref={dropdownButtonRef}
            aria-label="Mostrar mais opções"
            className="relative"
            icon={<Icon name="more-alt" />}
            size="size3"
            type="neutral-ghost"
            onClick={() => {
              setDropdownOpen((prev) => !prev);
            }}
          />
          <Dropdown
            align="left"
            className="z-50 min-w-max rounded-3 bg-neutral-high-100 p-2 shadow-[0px_0px_10px_0px_rgba(87,87,87,0.2)] dark:border dark:border-neutral-high-200 dark:bg-neutral-low-500"
            open={isDropdownOpen}
            openerRef={dropdownButtonRef}
            renderToHTML
            onClickOutside={() => {
              setDropdownOpen(false);
            }}
          >
            <CombinedNavContent
              addContentRef={addContentRef}
              className="w-full flex-col"
              gaEventCategory={gaEventCategory}
              overflowMap={overflowMap}
              showOnlyOverflowed={true}
              startIndex={startIndexCountingSiblings}
            />
          </Dropdown>
        </div>
      )}
    </div>
  );
};

TopbarBottom.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
};

export default TopbarBottom;
